import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import logo from '../../../../assets/images/logo.png'
import FavoriteIcon from '@mui/icons-material/Favorite';
import CoffeeIcon from '@mui/icons-material/Coffee';
const Footer = () => {
  const theme = useTheme();
  const { mode } = theme.palette;

  return (
    <Grid container spacing={2}>
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          width={1}
        >
          <Box
            display={'flex'}
            component="a"
            href="/"
            title="Course Pool"
            width={100}
          >
            <Box
              component={'img'}
              src={
                mode === 'light'
                  ? logo
                  : logo
              }
              width={100}
            />
          </Box>
          
        </Box>

      <Grid item xs={12}>
        <Typography
          align={'center'}
          variant={'subtitle2'}
          color="text.secondary"
          gutterBottom
        >
          &copy; Course Pool. 2022. All rights reserved
        </Typography>
        <Typography
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          align={'center'}
          variant={'caption'}
          color="text.secondary"
          component={'p'}
        >
          Made with  <FavoriteIcon sx={{marginX: '5px'}} fontSize='small'/>  and  <CoffeeIcon sx={{marginX: '5px'}} fontSize='small'/>  by Hung Tran
        </Typography>
       
      </Grid>
    </Grid>
  );
};

export default Footer;
